import { en } from '@/i18n/messages/en';
import { ja } from '@/i18n/messages/ja';
import { vi } from '@/i18n/messages/vi';
import type { Locale, Messages } from '@/i18n/types';

export const catalogs: Record<Locale, Messages> = { en, ja, vi };
